// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"cc29e1c0","123":"bd176c85","130":"abf6c82b","145":"1491080f","200":"bcdd7ba1","346":"5458131b","390":"ddfb6f65","488":"9aa6f4d1","577":"3fda5db8","647":"222d668d","715":"2e1da9d1"}[chunkId] + ".chunk.js";
};